import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Download30 from '../views/Download30.vue'
import DownloadFree from '../views/DownloadFree.vue'
import DownloadLanding from '../views/DownloadLanding.vue'
import DownloadPaid from '../views/DownloadPaid.vue'
import DownloadUpgrade from '../views/DownloadUpgrade.vue'
import SupportLanding from '../views/SupportLanding.vue'
import AboutLanding from "@/views/AboutLanding.vue";
import AboutPrivacy from "@/views/AboutPrivacy.vue";
//import Landing from "@/views/Home.vue";
import AboutCookies from "@/views/AboutCookies.vue";
import AboutPayment from "@/views/AboutPayment.vue";
import Download33 from "@/views/Download33.vue";
import AboutPaymentPaddle from "@/views/AboutPaymentPaddle.vue";
import Checkout from "@/views/Checkout.vue";
import AboutPrivacy2 from "@/views/AboutPrivacy2.vue";

Vue.use(VueRouter)

// const landingRoutes: Array<RouteConfig> = [
//   {
//     path: '',
//     name: 'Landing2',
//     component: Landing
//   },
//   {
//     path: '/landing',
//     name: 'Landing1',
//     component: Landing
//   },
//   {
//     path: '/index.php',
//     redirect: '/'
//   }
// ];

// export const LandingRouter = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes: landingRoutes
// });

const downloadRoutes: Array<RouteConfig> = [
  {
    path: '/download',
    name: 'DownloadLanding',
    component: DownloadLanding
  },
  {
    path: '/download/free',
    name: 'Download33',
    component: Download33
  },
  {
    path: '/download/paid',
    name: 'DownloadPaid',
    component: Download33
  },
  {
    path: '/download/paid30',
    name: 'DownloadPaid30',
    component: Download30
  },
  {
    path: '/download/upgrade',
    name: 'DownloadUpgrade',
    component: DownloadUpgrade
  },
  {
    path: '/download/gp30',
    name: 'Download30',
    component: Download30
  },
  {
    path: '/download/gp32',
    name: 'Download30',
    component: Download30
  },
  {
    path: '/download/gp33',
    name: 'Download33',
    component: Download33
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: Checkout
  }
]

export const DownloadRouter = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: downloadRoutes
});


export const SupportRouter = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/support',
      name: 'SupportLanding',
      component: SupportLanding
    },
  ]
})

export const AboutRouter = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/about',
      component: AboutLanding
    },
    {
      path: '/about/cookies',
      component: AboutCookies
    },
    {
      path: '/about/payment',
      component: AboutPayment
    },
    {
      path: '/about/payment-paddle',
      component: AboutPaymentPaddle
    },
    {
      path: '/about/privacy',
      component: AboutPrivacy
    },
    {
      path: '/about/privacy-desktop',
      component: AboutPrivacy2
    },
    {
      path: '/about/feed',
      redirect: '/about/privacy#feed'
    }
  ]
})
